import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { GetQuestionsBySubject } from '../services/apiservice';
import InterviewQuestionItem from '../Components/InterviewQuestionItem';
import Loader from '../Components/Loader';

const InterviewQuestionsAnswers = () => {
  const { subject } = useParams();
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize] = useState(50);

  const fetchQuestions = async () => {
    try {
      setLoading(true);
      const questionList = await GetQuestionsBySubject(subject, pageNumber, pageSize);
      //const jsonQuestionList = JSON.parse(questionList);

      const jsonQuestionList = JSON.parse(questionList);
      setQuestions(jsonQuestionList.question || []);
    } catch (error) {
      console.error('Error fetching interview questions:', error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (subject) {
      fetchQuestions();
    }
  }, [subject, pageNumber]);

  return (
    <div>


      <Header />

      <div className="page-title-area">
        <div className="container">
          <div className="page-title-content">
            <h2>{subject} Interview Questions</h2>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/interviewlist">Interview</a></li>
              <li className="active">{subject}</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="interview-area ptb-20">
        <div className="container-block-fluid">
          <div className="row justify-content-center">
            <div className="full-col col-lg-12 col-md-12">
              {loading ? (
                <Loader />
              ) : questions?.length === 0 ? (
                <div className="text-center">
                  <p>No interview questions available for this subject yet.</p>
                </div>
              ) : (
                <div className="container-fluid">
                  <div className="row justify-content-center">
                    <div className="col-12 col-sm-12 col-md-11 col-lg-10 col-xl-8">
                      <div className="full-col">
                        <div
                          className="faq-accordion"
                          data-aos="fade-up"
                          data-aos-duration="1600"
                        >
                          <ul className="accordion">
                            {questions?.map((question, index) => (
                              <InterviewQuestionItem
                                key={question.id}
                                question={question}
                                index={index + 1}
                              />
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                // <div className="container-fluid">
                //   <div className="row">

                //     <div className="col-2">
                //     </div>
                //     <div className="col-8">
                //       <div className="full-col">
                //         <div className="faq-accordion" data-aos="fade-up"
                //           data-aos-duration="1600">
                //           <ul className="accordion">

                //             {questions?.map((question, index) => (
                //               <InterviewQuestionItem
                //                 key={question.id}
                //                 question={question}
                //                 index={index + 1}
                //               />
                //             ))}

                //           </ul>
                //         </div>
                //       </div>
                //     </div>
                //     <div className="col-2">
                //     </div>
                //   </div>
                // </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default InterviewQuestionsAnswers;